import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class UrlService {
  private _previousUrl: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public previousUrl: Observable<string> = this._previousUrl.asObservable();
  
  constructor() { }
  
  public setPreviousUrl(previousUrl: string) {
    this._previousUrl.next(previousUrl);
  }
}